import { useMutation } from "@apollo/client/react"; import React, { useState } from 'react';
import ClearIcon from "@mui/icons-material/Clear";
import { RenderInputByTypeMobile } from '../../../components/formGroupGenerator/RenderInputByTypeMobile';
import { CustomDialog } from '../../../components/customDialog/CustomDialog';

import ANULAR_VISITA from '../../../data/graphQL/mutations/ControlVisita/anularVisita';
import toast from 'react-hot-toast';

export const AnularModal = ({ idVisita, reload }) => {
  const [openModal, setOpenModal] = useState(false);
  const [observacion, setObservacion] = useState('');

  const [anularVisita, { loading }] = useMutation(ANULAR_VISITA, {
    fetchPolicy: 'no-cache',
    variables: {
      idVisita: idVisita,
      observacion: observacion
    }
  });

  const handleOpenModal = () => {
    setOpenModal(true);
  };
  const handleCloseModal = () => {
    setObservacion(null);
    setOpenModal(false);
  };

  const handleAccept = () => {
    anularVisita().then(() => {
      toast.success('Visita anulada.');
      reload();
      handleCloseModal();
    });
  };

  return (
    <>
      <div aria-hidden='true' onClick={() => handleOpenModal()} className='item-option clickable-option'>
        <ClearIcon className='edit-icon' />
        <span className='toggle-action'>Anular</span>
      </div>
      <CustomDialog
        maxWidth="sm"
        fullWidth={true}
        open={openModal}
        title={'Anulación'}
        onCancel={handleCloseModal}
        onAccept={handleAccept}
        acceptText='Guardar'
        cancelText='Cerrar'
        acceptLoading={loading}
        cancelLoading={loading}>

        <RenderInputByTypeMobile
          input={{
            name: 'observacion',
            type: 'long_string',
            displayName: 'Justificación'
          }}
          value={observacion}
          handleChange={(name, value) => setObservacion(value)} />

      </CustomDialog>
    </>);

};